<template>
  <div>
    <el-card>
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <div style="font-weight:600;display:flex;align-items:center;gap:16px;">
          商品维护
          <el-input
            v-model="searchQuery"
            placeholder="搜索商品名称或SKU"
            style="width:400px;"
            clearable
            @keyup.enter.native="handleSearch"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
          <el-select
            v-model="searchStatus"
            placeholder="选择状态"
            style="width:120px;"
            @change="handleSearch"
          >
            <el-option label="所有" value="-1"></el-option>
            <el-option label="上架" value="1"></el-option>
            <el-option label="下架" value="0"></el-option>
          </el-select>
        </div>
        <div style="display:flex;gap:10px;">
          <el-button type="primary" plain @click="fetchSkuList">刷新列表</el-button>
        </div>
      </div>
      <el-table 
        v-loading="loading" 
        element-loading-text="正在加载中..."
        :data="products" 
        style="width: 100%; margin-top: 16px;"
      >
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="sku_no" label="SKU编号" width="120" />
        <el-table-column label="图片" width="80">
          <template slot-scope="scope">
            <el-image
              v-if="getListPicture(scope.row)"
              :src="getListPicture(scope.row)"
              style="width:50px;height:50px;"
              fit="cover"
            />
            <div v-else
              style="width:50px;height:50px;background:#f5f5f5;display:flex;align-items:center;justify-content:center;color:#999;font-size:12px;">
              无图</div>
          </template>
        </el-table-column>
        <el-table-column prop="sku_name" label="商品名称" min-width="150" />
        <el-table-column prop="sku_spec" label="规格" width="250" />
        <!-- <el-table-column prop="category_code" label="分类编码" width="100" /> -->
        <el-table-column prop="sell_price" label="售价(¥)" width="100" />
        <el-table-column prop="sku_stock" label="库存" width="90" />
        <el-table-column prop="unit" label="单位" width="60" />
        <el-table-column prop="manufacturer" label="生产厂家" width="150" show-overflow-tooltip />
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
              {{ scope.row.status === 1 ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="isEdit ? '编辑商品' : '新增商品'"
      :visible.sync="dialogVisible"
      width="40%"
      custom-class="product-edit-dialog"
    >
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="SKU编号" prop="sku_no">
              <el-input v-model="form.sku_no" placeholder="系统自动生成或手动输入" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="0">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="商品名称" prop="sku_name">
              <el-input v-model="form.sku_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否推荐">
              <el-radio-group v-model="form.is_recommand">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="规格" prop="sku_spec">
              <el-input v-model="form.sku_spec" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位" prop="unit">
              <el-input v-model="form.unit" placeholder="如：盒、瓶" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="售价" prop="sell_price">
              <el-input-number v-model="form.sell_price" :min="0" :step="0.1" :precision="2" controls-position="right"
                style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存" prop="sku_stock">
              <el-input-number v-model="form.sku_stock" :min="0" controls-position="right" style="width:100%" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="生产厂家" prop="manufacturer">
              <el-input v-model="form.manufacturer" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="批准文号" prop="approval_number">
              <el-input v-model="form.approval_number" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品图片">
          <div class="uploader-container">
            <div class="uploader-list">
              <div
                v-for="(pic, index) in form.sku_pictures"
                :key="index"
                class="uploader-item"
              >
                <el-image :src="pic" class="uploader-image" fit="cover" />
                <span class="uploader-remove" @click="removePicture(index)">
                  <i class="el-icon-delete"></i>
                </span>
              </div>
              <el-upload 
                v-if="!form.sku_pictures || form.sku_pictures.length < 4"
                class="uploader" 
                :auto-upload="false" 
                :show-file-list="false" 
                :http-request="handleUpload"
                :on-change="onFileChange" 
                accept="image/*"
                multiple
                :limit="4"
              >
                <i class="el-icon-plus uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div style="color: #909399; font-size: 12px; margin-top: 10px;">
            最多上传4张图片
          </div>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark"  disabled />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { SkuList, SkuEdit } from '@/api/api.js'

export default {
  name: 'AdminProducts',
  data() {
    return {
      loading: false,
      products: [],
      dialogVisible: false,
      isEdit: false,
      editingId: null,
      searchQuery: '',
      searchStatus: '-1',
      form: {
        sku_no: '',
        sku_name: '',
        category_code: '',
        sell_price: 0,
        sku_stock: 0,
        sku_pictures: [],
        sku_spec: '',
        manufacturer: '',
        approval_number: '',
        unit: '',
        status: 1,
        sort: 0,
        is_recommand: 0
      },
      rules: {
        sku_name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        category_code: [{ required: true, message: '请输入分类编码', trigger: 'blur' }],
        sell_price: [{ required: true, message: '请输入售价', trigger: 'change' }],
        sku_stock: [{ required: true, message: '请输入库存', trigger: 'change' }]
      }
    }
  },
  created() {
    this.fetchSkuList()
  },
  methods: {
    async fetchSkuList() {
      this.loading = true
      const params = {
        status: -1,
        keyword: ''
      }
      SkuList(params).then(res => {
        console.log(res);
        this.products = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.loading = true
      // 使用SkuSearch接口进行搜索，参数包括status和keyword
      const params = {
        status: parseInt(this.searchStatus),
        keyword: this.searchQuery || ''
      }
      SkuList(params).then(res => {
        console.log(res);
        this.products = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    openAdd() {
      this.isEdit = false
      this.editingId = null
      this.resetForm()
      this.dialogVisible = true
    },
    openEdit(row) {
      this.resetForm()
      this.isEdit = true
      this.editingId = row.id
      Object.assign(this.form, row)

      const rawPictures = row.pictures
      if (rawPictures) {
        let list = []
        if (Array.isArray(rawPictures)) {
          list = rawPictures
        } else if (typeof rawPictures === 'string' && rawPictures.trim()) {
          try {
            const parsed = JSON.parse(rawPictures)
            if (Array.isArray(parsed)) {
              list = parsed
            } else {
              list = [parsed]
            }
          } catch (e) {
            // 处理逗号分隔的字符串链接
            if (rawPictures.includes(',')) {
              list = rawPictures.split(',').map(p => p.trim()).filter(p => p)
            } else {
              list = [rawPictures]
            }
          }
        }

        const urls = list
          .map(item => {
            if (!item) return null
            if (typeof item === 'string') {
              if (item.indexOf('http') === 0 || item.indexOf('data:') === 0) {
                return item
              }
              return 'data:image/jpeg;base64,' + item
            }
            const url = item.url
            if (url && (url.indexOf('http') === 0 || url.indexOf('data:') === 0)) {
              return url
            }
            const raw = item.picture_base64 || item.base64 || item.ImgBase64 || item.imageBase64 || ''
            if (!raw) return null
            if (raw.indexOf('data:') === 0) {
              return raw
            }
            return 'data:image/jpeg;base64,' + raw
          })
          .filter(Boolean)

        this.$set(this.form, 'sku_pictures', urls)
      }
      if (this.form.sku_picture && !this.form.sku_pictures) {
        this.$set(this.form, 'sku_pictures', [this.form.sku_picture])
        delete this.form.sku_picture
      } else if (!this.form.sku_pictures) {
        this.$set(this.form, 'sku_pictures', [])
      }
      if (this.form.is_recommand === undefined) this.form.is_recommand = 0
      this.dialogVisible = true
    },
    getListPicture(row) {
      if (!row) return ''
      const direct = row.sku_picture
      if (direct && typeof direct === 'string') {
        const v = direct.trim()
        if (v && (v.indexOf('http') === 0 || v.indexOf('data:') === 0)) {
          return v
        }
      }
      const rawPictures = row.pictures
      if (!rawPictures) return ''
      let first = null
      if (Array.isArray(rawPictures)) {
        first = rawPictures[0]
      } else if (typeof rawPictures === 'string' && rawPictures.trim()) {
        try {
          const parsed = JSON.parse(rawPictures)
          if (Array.isArray(parsed)) {
            first = parsed[0]
          } else {
            first = parsed
          }
        } catch (e) {
          // 处理逗号分隔的字符串链接
          if (rawPictures.includes(',')) {
            const pictures = rawPictures.split(',').map(p => p.trim()).filter(p => p)
            first = pictures[0] || ''
          } else {
            first = rawPictures
          }
        }
      } else if (typeof rawPictures === 'object') {
        first = rawPictures
      }
      if (!first) return ''
      if (typeof first === 'string') {
        const v = first.trim()
        if (!v) return ''
        if (v.indexOf('data:') === 0 || v.indexOf('http') === 0) return v
        return 'data:image/jpeg;base64,' + v
      }
      const url = first.url
      if (url && (url.indexOf('http') === 0 || url.indexOf('data:') === 0)) {
        return url
      }
      const raw = first.picture_base64 || first.base64 || first.ImgBase64 || first.imageBase64 || ''
      if (!raw) return ''
      if (raw.indexOf('data:') === 0) return raw
      return 'data:image/jpeg;base64,' + raw
    },
    resetForm() {
      this.form = {
        sku_no: '',
        sku_name: '',
        category_code: '',
        sell_price: 0,
        sku_stock: 0,
        sku_pictures: [],
        sku_spec: '',
        manufacturer: '',
        approval_number: '',
        unit: '',
        status: 1,
        sort: 0,
        is_recommand: 0
      }
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return

        if (this.isEdit) {
          const picturesArray = Array.isArray(this.form.sku_pictures) ? this.form.sku_pictures : []
          const picturesBase64List = picturesArray
            .map((url) => {
              if (!url) return null
              if (url.indexOf('data:') === 0) {
                const commaIndex = url.indexOf(',')
                if (commaIndex !== -1) {
                  return url.slice(commaIndex + 1)
                }
              }
              return url
            })
            .filter(Boolean)

          const payload = {
            sku_no: this.form.sku_no,
            status: this.form.status,
            sell_price: this.form.sell_price,
            pictures: picturesBase64List,
            is_recommand: this.form.is_recommand || 0
          }

          SkuEdit(payload).then(res => {
            if (res.code === 200 || res.status === 200 || res.success) { // Adjust based on actual API response structure
              this.$message.success('更新成功')
              this.fetchSkuList()
              this.dialogVisible = false
            } else {
              this.$message.error(res.msg || '更新失败')
            }
          }).catch(err => {
            console.error(err)
            this.$message.error('请求失败')
          })
        }
      })
    },
    remove(id) {
      this.$confirm('确认删除该商品吗？', '提示', { type: 'warning' })
        .then(() => {
          this.products = this.products.filter(p => p.id !== id)
        })
        .catch(() => { })
    },
    handleUpload(req) {
      const file = req.file
      const reader = new FileReader()
      reader.onload = e => {
        if (!Array.isArray(this.form.sku_pictures)) {
          this.$set(this.form, 'sku_pictures', [])
        }
        if (this.form.sku_pictures.length < 4) {
          this.form.sku_pictures.push(e.target.result)
        }
      }
      reader.readAsDataURL(file)
    },
    onFileChange(file) {
      // When using multiple attribute, on-change event is triggered for each file individually
      if (file.raw) {
        this.handleUpload({ file: file.raw })
      }
    },
    removePicture(index) {
      if (this.form.sku_pictures && this.form.sku_pictures.length > index) {
        this.form.sku_pictures.splice(index, 1)
      }
    }
  }
}
</script>

<style>
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-edit-dialog {
  margin: 0 auto !important;
}

.uploader-container {
  display: block;
}

.uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  width: 120px !important;
  height: 120px;
}

.uploader-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.uploader-item {
  position: relative;
  width: 120px !important; 
  height: 120px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
}

.uploader-remove {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
  font-size: 14px;
}

.uploader-image {
  width: 120px;
  height: 120px;
  display: block;
}

.uploader-remove:hover {
  background: rgba(0, 0, 0, 0.7);
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
